import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import { FDContentContainer } from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { AccountOpeningV2UncommonSituationsUploadStepLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

export const AccountOpeningV2UncommonSituationsUploadStepTemplate = ({ resource }) => {
  const { setPageContentCollection, refreshPageContentCollection, loadPageContentLink } = usePageContentContext();
  return (
    <WorkflowLayout appearance="elevated" resource={resource}>
      <FDContentContainer maxWidth="sm">
        <MetaResourceRenderer
          metaOverrideSet={metaOverrideSet}
          layout={AccountOpeningV2UncommonSituationsUploadStepLayout}
          LayoutProps={{ refreshCollection: refreshPageContentCollection, navigateToLink: loadPageContentLink }}
          resource={resource}
          onSubmit={setPageContentCollection}
        />
      </FDContentContainer>
    </WorkflowLayout>
  );
};

AccountOpeningV2UncommonSituationsUploadStepTemplate.defaultProps = {
};

AccountOpeningV2UncommonSituationsUploadStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
